export { default } from '@/features/campaignsStatistics/api';
